/*
    refer to front/javascript/app/common/data/routeIds.ts for old url naming params
*/
export enum BusinessModalQueryParams {
    IncludedBusinesses = 'included',
    ExcludedBusinesses = 'excluded',
    Groups = 'groups',
    OrgId = 'org_id',
    Orgs = 'orgs',
    BusinessOrgId = 'business_org_id',
    Search = 'queries',
    City = 'cities',
}

export const queryParamToRequestParamMap: Record<BusinessModalQueryParams, string> = {
    [BusinessModalQueryParams.IncludedBusinesses]: 'business__in',
    [BusinessModalQueryParams.ExcludedBusinesses]: 'business__notin',
    [BusinessModalQueryParams.Groups]: 'groups',
    [BusinessModalQueryParams.OrgId]: 'org_id',
    [BusinessModalQueryParams.Orgs]: 'business_org_id',
    [BusinessModalQueryParams.BusinessOrgId]: 'business_org_id',
    [BusinessModalQueryParams.Search]: 'queries',
    [BusinessModalQueryParams.City]: 'cities',
};

export const requestParamToQueryParamMap: Record<string, BusinessModalQueryParams> = {
    business__in: BusinessModalQueryParams.IncludedBusinesses,
    business__notin: BusinessModalQueryParams.ExcludedBusinesses,
    groups: BusinessModalQueryParams.Groups,
    org_id: BusinessModalQueryParams.OrgId,
    business_org_id: BusinessModalQueryParams.BusinessOrgId,
};
